export default __webpack_public_path__ + "static/media/chevrolet.3412e3d3.svg";